import './confirm-modal.style.sass';
import template from './confirm-modal.tpl.pug';

class ConfirmDeleteController {
    $onChanges(changeObject) {
        if (changeObject.message) {
            this.paragraphs = typeof this.message === 'string'
                ? [this.message]
                : this.message;
        }

        if (changeObject.primaryButton) {
            if (typeof this.primaryButton === 'string') {
                this.primaryButtonText = this.primaryButton;
                this.primaryButtonLoadingText = this.primaryButtonText;
            } else if (this.primaryButton) {
                this.primaryButtonText = this.primaryButton[0];
                this.primaryButtonLoadingText = this.primaryButton[1] || this.primaryButtonText;
            } else {
                this.primaryButtonText = 'Yes, delete';
                this.primaryButtonLoadingText = 'Deleting...';
            }
        }

        if (changeObject.checkboxPrimaryButton) {
            if (typeof this.checkboxPrimaryButton === 'string') {
                this.checkboxPrimaryButtonText = this.checkboxPrimaryButton;
                this.checkboxPrimaryButtonLoadingText = this.checkboxPrimaryButtonText;
            } else if (this.checkboxPrimaryButton) {
                this.checkboxPrimaryButtonText = this.checkboxPrimaryButton[0];
                this.checkboxPrimaryButtonLoadingText = this.checkboxPrimaryButton[1] || this.checkboxPrimaryButtonText;
            } else {
                this.checkboxPrimaryButtonText = null;
                this.checkboxPrimaryButtonLoadingText = null;
            }
        }

        if (changeObject.secondaryButton) {
            this.secondaryButtonText = this.secondaryButton || 'Cancel';
        }

        if (changeObject.buttonStyle) {
            this.buttonStyleClass = this.buttonStyle || 'button-danger';
        }

        if (changeObject.checkboxDefault) {
            this.checkboxChecked = !!this.checkboxDefault;
        }
    }

    $onInit() {
        this.buttonStyleClass = this.buttonStyle || 'button-danger';
        this.checkboxChecked = !!this.checkboxDefault;
    }

    cancel() {
        return this.onDismiss();
    }

    confirm() {
        return this.onClose({
            data: this.checkboxChecked
        });
    }

    getPrimaryButtonText() {
        if (this.checkboxChecked && this.checkboxPrimaryButtonText) {
            return this.checkboxPrimaryButtonText;
        }

        return this.primaryButtonText;
    }

    getPrimaryButtonLoadingText() {
        if (this.checkboxChecked && this.checkboxPrimaryButtonLoadingText) {
            return this.checkboxPrimaryButtonLoadingText;
        }

        return this.primaryButtonLoadingText;
    }
}

export default {
    selector: 'dbAConfirmModal',
    template: template(),
    controller: ConfirmDeleteController,
    bindings: {
        title: '<',
        message: '<',
        primaryButton: '<',
        checkboxPrimaryButton: '<',
        secondaryButton: '<',
        buttonStyle: '<',
        wide: '<',
        checkboxLabel: '<',
        checkboxDefault: '<',
        onDismiss: '&',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/confirm-modal/confirm-modal.cmpt.js